<template>
  <div>
    <v-data-table
      :headers="getTableHeaders()"
      :items="collections.filter(c => c.studies.length > 0)"
      item-key="id"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:item="props">
        <tr :key="'tr-' + props.item.label + '-' + props.item.id">
          <td class="text-subtitle-1 text-xs-left">
            <v-tooltip top color="primary">
              <template v-slot:activator="{ on: tooltip }">
                <span v-on="{ ...tooltip }">{{ props.item.label }}</span>
              </template>
              <span class="subtitle-1">{{
                getCollectionDescription(props.item)
              }}</span>
            </v-tooltip>
          </td>
          <td v-if="showOwner" class="text-subtitle-1 text-xs-center">
            {{ props.item.user_name }}
          </td>
          <td v-if="showGroup" class="text-subtitle-1 text-xs-center">
            {{
              props.item.is_public
                ? 'Public'
                : getGroupName(props.item.group_id)
            }}
          </td>
          <td class="text-subtitle-1 text-xs-center">
            <v-tooltip
              v-if="props.item.studies[0].study.longitudinal"
              top
              color="primary"
            >
              <template v-slot:activator="{ on: tooltip }">
                <span v-on="{ ...tooltip }">
                  <v-chip
                    label
                    class="font-weight-bold px-2"
                    color="green lighten-4"
                    ><span class="ma-0 pa-0" style="width: 0.4em;"></span>L<span
                      class="ma-0 pa-0"
                      style="width: 0.4em;"
                    ></span
                    ><v-icon v-if="false" class="pl-2"
                      >mdi-chart-timeline-variant</v-icon
                    ></v-chip
                  >
                </span>
              </template>
              <span class="subtitle-1">Longitudinal</span>
            </v-tooltip>

            <v-tooltip v-else top color="primary">
              <template v-slot:activator="{ on: tooltip }">
                <v-chip
                  label
                  class="font-weight-bold px-2"
                  color="blue lighten-4"
                  v-on="{ ...tooltip }"
                  >CS<v-icon v-if="false" class="pl-2"
                    >mdi-drag-vertical-variant</v-icon
                  ></v-chip
                >
              </template>
              <span class="subtitle-1">Cross-sectional</span>
            </v-tooltip>
          </td>
          <td>
            <v-tooltip top color="primary">
              <template v-slot:activator="{ on: tooltip }">
                <v-icon
                  color="primary"
                  class="mr-1"
                  @click="openStudyDatasetSummary(props.item.id)"
                  v-on="{ ...tooltip }"
                  >info</v-icon
                >
              </template>
              <span class="subtitle-1">View study dataset summary.</span>
            </v-tooltip>
          </td>
          <td class="text-subtitle-1 text-xs-left">
            {{ props.item.date_generated | formatDate }}
          </td>
          <td class="text-subtitle-1 text-xs-left">
            <v-tooltip
              v-if="collectionAndStudiesArePublic(props.item)"
              top
              color="primary"
            >
              <template v-slot:activator="{ on: tooltip }">
                <span v-on="{ ...tooltip }">
                  <v-chip
                    label
                    class="font-weight-bold pa-2 mr-2"
                    color="green lighten-4"
                  >
                    <v-icon center :small="dense"
                      >mdi-lock-open-variant-outline</v-icon
                    >
                  </v-chip>
                </span>
              </template>
              <span class="subtitle-1"> Public </span>
            </v-tooltip>

            <v-tooltip v-else top color="primary">
              <template v-slot:activator="{ on: tooltip }">
                <span v-on="{ ...tooltip }">
                  <v-chip
                    label
                    class="font-weight-bold pa-2 mr-2"
                    color="red lighten-4"
                  >
                    <v-icon center :small="dense">mdi-lock-outline</v-icon>
                  </v-chip>
                </span>
              </template>
              <span class="subtitle-1"> Private </span>
            </v-tooltip>
          </td>
          <!-- -------------------------------This part creates all of the buttons-------------------------------------------------------- -->
          <td class="text-subtitle-1 text-xs-left px-0 btnGroup">
            <v-tooltip top color="primary">
              <template v-slot:activator="{ on: tooltip }">
                <v-btn
                  small
                  class="mr-2"
                  @click="routeToBuildDataset(props.item)"
                  v-on="{ ...tooltip }"
                  ><v-icon left small color="secondary">mdi-plus-minus</v-icon
                  >{{ dense ? 'Variables' : 'Add/Remove Vars' }}
                </v-btn>
              </template>
              <span class="subtitle-1"
                >Add and/or remove variables from an existing Study
                Dataset</span
              >
            </v-tooltip>

            <v-tooltip top color="primary">
              <template v-slot:activator="{ on: tooltip }">
                <v-btn
                  :disabled="props.item.studies[0].study.longitudinal == 0"
                  small
                  class="mr-2"
                  @click="routeToDataSummary(props.item)"
                  v-on="{ ...tooltip }"
                  ><v-icon left small color="secondary"
                    >mdi-chart-timeline</v-icon
                  >{{ dense ? 'Visits' : 'Set Visits' }}
                </v-btn>
              </template>
              <span class="subtitle-1"
                >View Data Summary and choose First &amp; Last Visit</span
              >
            </v-tooltip>
            <!-- ADD STUDY GROUPS -->
            <v-tooltip top color="primary">
              <template v-slot:activator="{ on: tooltip }">
                <v-btn
                  :disabled="!props.item.variable_visits_set"
                  small
                  class="mr-2"
                  @click="routeToCohortManager(props.item)"
                  v-on="{ ...tooltip }"
                >
                  <v-icon left small color="secondary" class="pa-0"
                    >group_add</v-icon
                  >
                  {{ dense ? '' : 'Add Study ' }}Groups
                  <span style="font-family: monospace;">{{
                    String('[' + String(props.item.num_cohorts) + ']').padStart(
                      4,
                      '&nbsp;'
                    )
                  }}</span>
                </v-btn>
              </template>
              <span class="subtitle-1"
                >Launch Study Group Selector to add/remove Study Groups ({{
                  props.item.num_cohorts
                }}
                study group{{ props.item.num_cohorts > 1 ? 's' : '' }} created
                so far)</span
              >
            </v-tooltip>
            <!--  -->
            <v-tooltip top color="primary">
              <template v-slot:activator="{ on: tooltip }">
                <v-btn
                  :disabled="
                    props.item.num_cohorts == 0 ||
                      !props.item.variable_visits_set
                  "
                  small
                  class="mr-2"
                  @click="routeToDataExplorer(props.item)"
                  v-on="{ ...tooltip }"
                >
                  <v-icon left small color="secondary">analytics</v-icon
                  >{{ dense ? 'Analytics' : 'Data Analytics' }}
                </v-btn>
              </template>
              <span class="subtitle-1"
                >Analyze study groups, predictor variables, and outcomes.</span
              >
            </v-tooltip>

            <v-tooltip v-if="showDataExport" top color="primary">
              <template v-slot:activator="{ on: tooltip }">
                <v-btn
                  :disabled="
                    props.item.num_cohorts == 0 ||
                      !props.item.variable_visits_set
                  "
                  small
                  class="mr-2"
                  @click="routeToDataExporter(props.item)"
                  v-on="{ ...tooltip }"
                >
                  <v-icon left small color="secondary"
                    >mdi-database-export</v-icon
                  >
                  {{ dense ? 'Export' : 'Data Export' }}
                </v-btn>
              </template>
              <span class="subtitle-1">Export data in CSV format.</span>
            </v-tooltip>
          </td>

          <td class="text-subtitle-1 text-xs-left" style="white-space: nowrap;">
            <!-- chat -->
            <v-tooltip top color="primary">
              <template v-slot:activator="{ on: tooltip }">
                <span v-on="{ ...tooltip }">
                  <collection-chat
                    :collection="props.item"
                    :dense="dense"
                    class="mr-2"
                  ></collection-chat>
                </span>
              </template>
              <span class="subtitle-1">Team Chat</span>
            </v-tooltip>

            <!-- share -->
            <v-tooltip
              v-if="showShareOption && sharingGroups.length > 0"
              top
              color="primary"
            >
              <template v-slot:activator="{ on: tooltip }">
                <span v-on="{ ...tooltip }">
                  <share-collection-icon-dialog
                    :collection="props.item"
                    :gid2group="gid2group"
                    @collectionShared="collectionShared"
                  />
                </span>
              </template>
              <span class="subtitle-1">Share</span>
            </v-tooltip>

            <!-- copy -->
            <v-tooltip v-if="showDataCopy" top color="primary">
              <template v-slot:activator="{ on: tooltip }">
                <span v-on="{ ...tooltip }">
                  <copy-collection-icon-dialog
                    :collection="props.item"
                    :disabled="!props.item.variable_visits_set"
                    @collectionCopied="collectionCopied"
                  />
                </span>
              </template>
              <span class="subtitle-1">{{
                props.item.variable_visits_set
                  ? 'Copy'
                  : 'You must select visits before cloning this dataset'
              }}</span>
            </v-tooltip>

            <!-- rename -->
            <v-tooltip top color="primary">
              <template v-slot:activator="{ on: tooltip }">
                <span v-on="{ ...tooltip }">
                  <rename-collection-button
                    v-if="props.item.is_deletable"
                    :collection="props.item"
                    :collections="collections"
                  />
                </span>
              </template>
              <span class="subtitle-1">Rename</span>
            </v-tooltip>

            <!-- delete -->
            <v-tooltip top color="primary">
              <template v-slot:activator="{ on: tooltip }">
                <span v-on="{ ...tooltip }">
                  <delete-collection-button
                    v-if="props.item.is_deletable"
                    :collection-id="props.item.id"
                    :collection-name="props.item.label"
                    :show-button="false"
                  />
                </span>
              </template>
              <span class="subtitle-1">Delete</span>
            </v-tooltip>
          </td>
        </tr>
        <tr v-for="(cohort, index) in props.item.cohorts" :key="`ctr-${index}`">
          <td colspan="3">study group row</td>
        </tr>
      </template>
      <template v-slot:no-data>
        There are no saved study datasets.
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" width="60%" :fullscreen="fullscreen" scrollable>
      <v-card
        class="ma-0 pa-0 indigo lighten-5"
        :height="fullscreen ? '100vh' : '75vh'"
      >
        <v-card-title class="ma-0 pa-0">
          <v-toolbar class="primary">
            <v-icon color="white" large>menu_book</v-icon>
            <v-toolbar-title class="white--text pl-3"
              >Study Dataset Summary
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom color="primary">
              <template v-slot:activator="{ on: tooltip }">
                <v-btn
                  icon
                  class="white--text ma-0 pa-0 mr-2"
                  @click="fullscreen = !fullscreen"
                  v-on="{ ...tooltip }"
                >
                  <v-icon center>{{
                    fullscreen ? 'mdi-arrow-collapse' : 'mdi-arrow-expand'
                  }}</v-icon>
                </v-btn>
              </template>
              <span>{{
                fullscreen ? 'Exit fullscreen' : 'Expand to fullscreen'
              }}</span>
            </v-tooltip>
            <v-tooltip bottom color="primary">
              <template v-slot:activator="{ on: tooltip }">
                <v-btn
                  icon
                  class="white--text ma-0 pa-0"
                  @click="dialog = false"
                  v-on="{ ...tooltip }"
                >
                  <v-icon center>close</v-icon>
                </v-btn>
              </template>
              <span>Close</span>
            </v-tooltip>
          </v-toolbar>
        </v-card-title>

        <v-card-text class="ma-0 pa-0">
          <study-dataset-summary :id="clickedId" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { state as authState } from '@/store/modules/auth/types';
import { getCollectionDescription } from '@/utils/helpers';
import DeleteCollectionButton from '@/components/dashboard/DeleteCollectionBtnDialog';
import RenameCollectionButton from '@/components/dashboard/RenameCollectionBtnDialog';
import ShareCollectionIconDialog from '@/components/dashboard/ShareCollectionIconDialog';
import CopyCollectionIconDialog from '@/components/dashboard/CopyCollectionIconDialog';
import StudyDatasetSummary from '@/views/StudyDatasetSummary.vue';
import CollectionChat from '@/components/common/CollectionChat.vue';

export default {
  filters: {
    formatDate(ts) {
      // note that toISOString is going to give us UTC
      return new Date(ts).toISOString().substr(0, 10);
    },
  },
  components: {
    DeleteCollectionButton,
    RenameCollectionButton,
    ShareCollectionIconDialog,
    CopyCollectionIconDialog,
    StudyDatasetSummary,
    CollectionChat,
  },
  props: {
    collections: {
      type: Array,
      required: true,
    },
    showOwner: {
      type: Boolean,
      required: false,
    },
    showGroup: {
      type: Boolean,
      required: false,
    },
    showDataExport: {
      type: Boolean,
      required: false,
    },
    showShareOption: {
      type: Boolean,
      required: false,
    },
    showDataCopy: {
      type: Boolean,
      required: false,
    },
    dense: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      dialog: false,
      fullscreen: false,
      clickedId: 0,
      getCollectionDescription: getCollectionDescription,
      gid2group: {},
    };
  },
  computed: {
    ...mapState('auth', {
      user: authState.USER,
    }),
    sharingGroups() {
      let ulg = [];
      if (this.user != null) {
        this.user.groups.forEach(g => {
          if (g.is_leader || g.is_contributor) ulg.push(g);
        });
      }
      return ulg;
    },
  },
  mounted() {
    let g2n = {};
    this.user.groups.forEach(g => {
      g2n[g.group_id] = g;
    });
    this.gid2group = g2n;
  },
  methods: {
    // both the collection and its component studies are public
    collectionAndStudiesArePublic(c) {
      if (c && c.is_public === 1) {
        let studiesPublic = true;
        c.studies.forEach(s => {
          if (s.study.project.is_public === 0) {
            studiesPublic = false;
          }
        });
        return studiesPublic;
      }
      return false;
    },
    routeToBuildDataset({ id }) {
      this.$router.push(`datasets/build?collection=${id}`);
    },
    routeToDataSummary({ id }) {
      this.$router.push(`data_summary?collection=${id}`);
    },
    routeToCohortManager({ id }) {
      this.$router.push(`cohorts?collection=${id}`);
    },
    routeToDataExplorer({ id }) {
      this.$router.push(`explore?collection=${id}`);
    },
    routeToDataExporter({ id }) {
      this.$router.push(`export?collection=${id}`);
    },
    routeToAnalysisSummary({ id }) {
      this.$router.push(`summary?collection=${id}`);
    },
    openStudyDatasetSummary(id) {
      this.clickedId = id;
      this.dialog = true;
    },
    getTableHeaders() {
      let headers = [
        {
          text: 'Study Dataset',
          value: 'label',
          class: 'text-subtitle-1 font-weight-bold',
        },
      ];
      if (this.showOwner) {
        headers.push({
          text: 'Owner',
          value: 'user_name',
          class: 'text-subtitle-1 font-weight-bold',
        });
      }
      if (this.showGroup) {
        headers.push({
          text: 'Shared with',
          value: 'group_name',
          class: 'text-subtitle-1 font-weight-bold',
        });
      }
      headers = headers.concat([
        {
          text: 'Type',
          value: 'is_longitudinal',
          class: 'text-subtitle-1 font-weight-bold',
        },
        {
          text: 'Info',
          value: 'name',
          align: 'left',
          sortable: false,
          class: 'text-subtitle-1 font-weight-bold',
        },
        {
          text: 'Created',
          value: 'date_generated_epoch',
          class: 'text-subtitle-1 font-weight-bold',
        },
        {
          text: 'Access',
          value: 'is_public',
          class: 'text-subtitle-1 font-weight-bold',
        },
        {
          text: 'Available Actions',
          value: 'label',
          sortable: false,
          class: 'text-subtitle-1 font-weight-bold',
        },
        {
          text: '',
          value: 'name',
          align: 'left',
          sortable: false,
          class: 'text-subtitle-1 font-weight-bold',
        },
      ]);
      return headers;
    },
    getGroupName(gid) {
      if (gid === null) return '-';
      return gid in this.gid2group ? this.gid2group[gid].name : 'group ' + gid;
    },
    collectionShared(payload) {
      this.$emit('collectionShared', payload);
    },
    collectionCopied(payload) {
      this.$emit('collectionCopied', payload);
    },
  },
};
</script>

<style scoped>
.btnGroup {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
</style>
